/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class UserActionModalModel {
        public processActionWorkflowBlockId: string;
        public comment: string;
        public fileUploadProgress: number;
        public fileUploadErrorMessage: string;
        public effectiveDate: Date;
        public docIds: string[];
        public showEffectiveDate: boolean;

        constructor() {
            this.docIds = [];
            this.showEffectiveDate = false;
        }
    }
}